/**
 * 3rd party libs imports
 */

// installed via npm
require('sweetalert');